import { defineMessages } from 'react-intl';

export default defineMessages({
    repayLoading: {
        id: '_.processing_payment.modal.early_repayment.loading',
        defaultMessage:
            '{amount} is being repaid by your debit card ending {paymentMethod}...'
    },
    drawDownLoading: {
        id: '_.processing_payment.modal.draw_down.loading',
        defaultMessage: `We're sending {amount} to your bank account...`
    },
    interestOnlyExtensionLoading: {
        id: '_.processing_payment.modal.interest_only_extension.loading',
        defaultMessage: `We're extending your interest-only period...`
    },
    repaymentReductionLoading: {
        id: '_.processing_payment.modal.repayment_reduction.loading',
        defaultMessage: `We’re reducing your monthly repayments`
    },
    truelayerRepayLoading: {
        id: '_.processing_payment.modal.early_repayment_truelayer.loading',
        defaultMessage:
            'You are being redirected to Truelayer to complete the payment'
    }
});
